import React from 'react'
import { withRouter, Route, Switch, Redirect } from 'react-router-dom'

import Tabs from '../../components/tabs'
import Locales from './locales'
import Regions from './regions'
import ApplianceTypes from './applianceTypes'
import Appliances from './appliances'
import FoodKinds from './foodKinds'
import LibraryTexts from './libraryTexts'
import Tags from './tags'
import TagTypes from './tagTypes'
import LabelLevels from './labelLevels'
import Units from './units'
import Users from './users'

import S from './styled'

const tabs = [{
  label: 'Locales',
  value: 'locales',
  component: Locales,
},{
  label: 'Tag Types',
  value: 'tagTypes',
  component: TagTypes,
},{
  label: 'Tags',
  value: 'tags',
  component: Tags,
},{
  label: 'Regions',
  value: 'regions',
  component: Regions,
},{
  label: 'Library Texts',
  value: 'library-text',
  component: LibraryTexts,
},{
  label: 'Appliance Types',
  value: 'applianceTypes',
  component: ApplianceTypes,
},{
  label: 'Appliances',
  value: 'appliances',
  component: Appliances,
},{
  label: 'Food Categories',
  value: 'food-kinds',
  component: FoodKinds,
},{
  label: 'Label Levels',
  value: 'label-levels',
  component: LabelLevels,
},{
  label: 'Units',
  value: 'units',
  component: Units,
},{
  label: 'Users',
  value: 'users',
  component: Users,
}]

const empty = () => <div>not implemented yet</div>

const Admin = ({ history, match, fetchLocales }) => {
  const page = history.location.pathname.split('/')[2]
  return (
    <S.MainPage>
      <Tabs onChange={newPage => history.push(`/admin/${newPage}`)} selected={page} tabs={tabs}
        inverted leftTabs fullHeight
      >
        <Switch>
          {
            tabs.map(tab => (
              <Route
                key={tab.value}
                path={`/admin/${tab.value}`}
                exact
                component={tab.component || empty}
              />
            ))
          }
          <Redirect to={`/admin/${tabs[0].value}`}/>
        </Switch>
      </Tabs>
    </S.MainPage>
  )
}

export default withRouter(Admin)
